export default () => ({
  el: undefined,
  init() {
    mrp.log(`DataGridDemo init`);
    this.el = this.$el;
    const selected = sessionStorage.getItem("weather-selected");
    if (selected === undefined || selected === null) {
      return;
    }
    const route = `/hx/demos/weather/select/${selected}`;
    this.el.setAttribute("hx-trigger", "load");
    this.el.setAttribute("hx-get", route);
    htmx.process(this.el);
  },
});
